module.exports = __webpack_public_path__ + "static/media/addVehicle.353fccfd.svg";